export function getAIColours(){
  const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

  return DISTINCT
}
export function getAIConfig() {
  const groupsById = {

        ai_impact_life: {
      type: "likert",
      label: "AI impact: Your life",
      fulltext: "In the next five years, do you think artificial intelligence will make the following things mostly better, mostly worse, or not much different? Your own daily life",
      keys: [
        "model_impact_life_1_pred_n",
        "model_impact_life_2_pred_n",
        "model_impact_life_3_pred_n",
        "model_impact_life_4_pred_n",
      ],
      labels: {
        "model_impact_life_1_pred_n": "Mostly better",
        "model_impact_life_2_pred_n": "Not much different",
        "model_impact_life_3_pred_n": "Mostly worse",
        "model_impact_life_4_pred_n": "Don't know",
      },
      polarity: {
        pos: "model_impact_life_1_pred_n",
        neg: "model_impact_life_3_pred_n",
        neu: ["model_impact_life_2_pred_n", "model_impact_life_4_pred_n"],
      },
      colors: {
        "model_impact_life_1_pred_n": "#59a14f", // Green
        "model_impact_life_2_pred_n": "#bab0ab", // Gray
        "model_impact_life_3_pred_n": "#e15759", // Red
        "model_impact_life_4_pred_n": "#d3d3d3", // Light Gray
      },
      schema:"tracking",
      waves:[2,3,4]
    },

    // --- AI Impact Society ---
    ai_impact_society: {
      type: "likert",
      label: "AI impact: Society",
      fulltext: "In the next five years, do you think artificial intelligence will make the following things mostly better, mostly worse, or not much different? Society as a whole",
      keys: [
        "model_impact_society_1_pred_n",
        "model_impact_society_2_pred_n",
        "model_impact_society_3_pred_n",
        "model_impact_society_4_pred_n",
      ],
      labels: {
        "model_impact_society_1_pred_n": "Mostly better",
        "model_impact_society_2_pred_n": "Not much different",
        "model_impact_society_3_pred_n": "Mostly worse",
        "model_impact_society_4_pred_n": "Don't know",
      },
      polarity: {
        pos: "model_impact_society_1_pred_n",
        neg: "model_impact_society_3_pred_n",
        neu: ["model_impact_society_2_pred_n", "model_impact_society_4_pred_n"],
      },
      colors: {
        "model_impact_society_1_pred_n": "#59a14f",
        "model_impact_society_2_pred_n": "#bab0ab",
        "model_impact_society_3_pred_n": "#e15759",
        "model_impact_society_4_pred_n": "#d3d3d3",
      },
      schema:"tracking",
      waves:[2,3,4]
    },

    // --- AI Copyright ---
    ai_copyright: {
      type: "categorical",
      label: "Should AI need copyright permission",
      fulltext: "At the moment, there is a big debate about whether AI companies should be allowed to use copyrighted content... Which of the following is closest to your view?",
      keys: [
        "model_ai_copyright_1_pred_n",
        "model_ai_copyright_2_pred_n",
        "model_ai_copyright_3_pred_n",
        "model_ai_copyright_4_pred_n",
      ],
      labels: {
        "model_ai_copyright_1_pred_n": "Always need persmission",
        "model_ai_copyright_2_pred_n": "Only if output resemples copyrighted content",
        "model_ai_copyright_3_pred_n": "Never need permission",
        "model_ai_copyright_4_pred_n": "Don't know",
      },
      full_labels: {
        "model_ai_copyright_1_pred_n": "Always need persmission",
        "model_ai_copyright_2_pred_n": "Only if output resemples copyrighted content",
        "model_ai_copyright_3_pred_n": "Never need permission",
        "model_ai_copyright_4_pred_n": "Don't know",
      },
      colors: {
        "model_ai_copyright_1_pred_n": "#4e79a7", // Blue (Strict)
        "model_ai_copyright_2_pred_n": "#b07aa1", // Purple (Middle)
        "model_ai_copyright_3_pred_n": "#59a14f", // Green (Open)
        "model_ai_copyright_4_pred_n": "#bab0ab", // Gray
      },
      schema:"single"
    },

    // --- AI Consume ---
    ai_consume: {
      type: "categorical",
      label: "Would you listen to AI-generated content",
      fulltext: "In this example, would you listen to this AI generated content?",
      keys: [
        "model_ai_consume_1_pred_n",
        "model_ai_consume_2_pred_n",
        "model_ai_consume_3_pred_n",
        "model_ai_consume_4_pred_n",
      ],
      labels: {
        "model_ai_consume_1_pred_n": "Yes",
        "model_ai_consume_2_pred_n": "Yes, but only with permission",
        "model_ai_consume_3_pred_n": "No",
        "model_ai_consume_4_pred_n": "Not sure",
      },
      full_labels: {
        "model_ai_consume_1_pred_n": "Yes",
        "model_ai_consume_2_pred_n": "Yes, but only with copyright holder’s permission",
        "model_ai_consume_3_pred_n": "No",
        "model_ai_consume_4_pred_n": "Not sure",
      },
      // polarity: {
      //   pos: ["model_ai_consume_1_pred_n", "model_ai_consume_2_pred_n"],
      //   neg: "model_ai_consume_3_pred_n",
      //   neu: "model_ai_consume_4_pred_n",
      // },
      colors: {
        "model_ai_consume_1_pred_n": "#59a14f", // Green
        "model_ai_consume_2_pred_n": "#76b7b2", // Teal
        "model_ai_consume_3_pred_n": "#e15759", // Red
        "model_ai_consume_4_pred_n": "#bab0ab", // Gray
      },
      schema:"single"
    },

    // --- AI Who Regulates ---
    ai_who_regulates: {
      type: "categorical",
      label: "Who should regulate AI?",
      fulltext: "Who do you think should play the primary role in setting the rules for how artificial intelligence is developed and used?",
      keys: [
        "model_who_regulates_AI_1_pred_n",
        "model_who_regulates_AI_2_pred_n",
        "model_who_regulates_AI_3_pred_n",
        "model_who_regulates_AI_4_pred_n",
        "model_who_regulates_AI_5_pred_n",
        "model_who_regulates_AI_6_pred_n",
      ],
      labels: {
        "model_who_regulates_AI_1_pred_n": "The federal government",
        "model_who_regulates_AI_2_pred_n": "State governments",
        "model_who_regulates_AI_3_pred_n": "Technology companies themselves",
        "model_who_regulates_AI_4_pred_n": "Independent experts / academics",
        "model_who_regulates_AI_5_pred_n": "International organizations",
        "model_who_regulates_AI_6_pred_n": "Don’t know"
      },
      // Categorical colors (no strict polarity)
      colors: {
        "model_who_regulates_AI_1_pred_n": "#4e79a7", // Blue
        "model_who_regulates_AI_2_pred_n": "#a0cbe8", // Light Blue
        "model_who_regulates_AI_3_pred_n": "#f28e2b", // Orange
        "model_who_regulates_AI_4_pred_n": "#59a14f", // Green
        "model_who_regulates_AI_5_pred_n": "#b07aa1", // Purple
        "model_who_regulates_AI_6_pred_n": "#bab0ab", // Gray
      },
      schema:"single"
    },

    // --- AI Tech Responsibility ---
    ai_tech_AI_responsibility: {
      type: "likert",
      label: "Trust technology companies around AI",
      fulltext: "How much do you trust technology companies to use artificial intelligence responsibly?",
      keys: [
        "model_tech_AI_responsibility_1_pred_n",
        "model_tech_AI_responsibility_2_pred_n",
        "model_tech_AI_responsibility_3_pred_n",
        "model_tech_AI_responsibility_4_pred_n",
        "model_tech_AI_responsibility_5_pred_n"
      ],
      labels: {
        "model_tech_AI_responsibility_1_pred_n": "A great deal",
        "model_tech_AI_responsibility_2_pred_n": "A fair amount",
        "model_tech_AI_responsibility_3_pred_n": "Not much",
        "model_tech_AI_responsibility_4_pred_n": "Not at all",
        "model_tech_AI_responsibility_5_pred_n": "Don't know"
      },
      polarity: {
        pos: ["model_tech_AI_responsibility_1_pred_n", "model_tech_AI_responsibility_2_pred_n"],
        neg: ["model_tech_AI_responsibility_3_pred_n", "model_tech_AI_responsibility_4_pred_n"],
        neu: "model_tech_AI_responsibility_5_pred_n",
      },
      colors: {
        "model_tech_AI_responsibility_1_pred_n": "#59a14f", // Green (High Trust)
        "model_tech_AI_responsibility_2_pred_n": "#8cd17d", // Yellow (Moderate Trust) - CHANGED from Teal
        "model_tech_AI_responsibility_3_pred_n": "#f9a099", // Orange (Low Trust)
        "model_tech_AI_responsibility_4_pred_n": "#e15759", // Red (No Trust)
        "model_tech_AI_responsibility_5_pred_n": "#bab0ab", // Gray
      },
      schema:"single"
    },

    // --- AI Concern Job Losses ---
    ai_concern_job_losses: {
      type: "likert",
      label: "Concern around AI job losses",
      fulltext: "How concerned are you that you or someone close to you will lose their job due to developments in artificial intelligence?",
      keys: [
        "model_concern_AI_job_losses_1_pred_n",
        "model_concern_AI_job_losses_2_pred_n",
        "model_concern_AI_job_losses_3_pred_n",
        "model_concern_AI_job_losses_4_pred_n",
        "model_concern_AI_job_losses_5_pred_n"
      ],
      labels: {
        "model_concern_AI_job_losses_1_pred_n": "Very concerned",
        "model_concern_AI_job_losses_2_pred_n": "Somewhat concerned",
        "model_concern_AI_job_losses_3_pred_n": "Not too concerned",
        "model_concern_AI_job_losses_4_pred_n": "Not at all concerned",
        "model_concern_AI_job_losses_5_pred_n": "Don't know"
      },
      polarity: {
        neg: ["model_concern_AI_job_losses_1_pred_n", "model_concern_AI_job_losses_2_pred_n"],
        pos: ["model_concern_AI_job_losses_3_pred_n", "model_concern_AI_job_losses_4_pred_n"],
        neu: "model_concern_AI_job_losses_5_pred_n",
      },
      colors: {
    
        "model_concern_AI_job_losses_1_pred_n": "#e15759", // Red (High Concern)
        "model_concern_AI_job_losses_2_pred_n": "#f9a099", // Orange
        "model_concern_AI_job_losses_3_pred_n": "#8cd17d", // Teal
        "model_concern_AI_job_losses_4_pred_n": "#59a14f", // Green (Low Concern)
        "model_concern_AI_job_losses_5_pred_n": "#bab0ab", // Gray
      },
      schema:"single"
    },

    // --- AI Pay Creatives ---
    ai_pay_creatives: {
      type: "likert",
      label: "Should artists be paid for AI use",
      fulltext: "Do you think that musicians, writers, and others who hold the copyright to this creative content should be paid for the use of their work?",
      keys: [
        "model_ai_pay_creatives_1_pred_n",
        "model_ai_pay_creatives_2_pred_n",
        "model_ai_pay_creatives_3_pred_n",
      ],
      labels: {
        "model_ai_pay_creatives_1_pred_n": "Yes",
        "model_ai_pay_creatives_2_pred_n": "No",
        "model_ai_pay_creatives_3_pred_n": "Don't know"
      },
      polarity: {
        pos: "model_ai_pay_creatives_1_pred_n",
        neg: "model_ai_pay_creatives_2_pred_n",
        neu: "model_ai_pay_creatives_3_pred_n",
      },
      colors: {
        "model_ai_pay_creatives_1_pred_n": "#59a14f", // Green
        "model_ai_pay_creatives_2_pred_n": "#e15759", // Red
        "model_ai_pay_creatives_3_pred_n": "#bab0ab", // Gray
      },
      schema:"single"
    },



  };

  
  return {  groupsById };
}
const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

export function buildLabelColorMaps(groupsById) {
  const labels = {};
  const colors = {};
  let colorIdx = 0;

  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = (g.labels && g.labels[k]) || k;

      // FIX: Check if the group config explicitly defines a color for this key FIRST
      if (g.colors && g.colors[k]) {
        colors[k] = g.colors[k];
      } 
      // Only use the generator if no manual color is found
      else if (g.type === "likert") {
        colors[k] = baseColorForLikertKey(g, k);
      } 
      // Fallback for categorical/other types
      else if (!colors[k]) {
        colors[k] = DISTINCT[colorIdx % DISTINCT.length];
        colorIdx += 1;
      }
    }
  }
  return { labels, colors };
}

export function aggregateWeighted(rows, keys, { rowKey, weight = "total", predicate = null } = {}) {
  const acc = Object.create(null);
  const zero = Object.fromEntries(keys.map(k => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;
    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };
    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

// utils/demoFilters.js (or wherever you keep it)

// Returns a predicate that matches your dataset’s integer-coded fields
export function buildDemoPredicate({
    gender = null,     // 1=Men, 2=Women
    age = null,        // 1=18–34, 2=35–64, 3=65+
    ethnicity = null,  // 1..5
    party = null,      // 1..4
    education = null,  // 1=No degree, 2=Degree
  } = {}) {
    return (r) => {
      // NOTE: r.<field> should be numbers in your data rows
      if (gender != null && Number(r.gender) !== Number(gender)) return false;
      if (age != null && Number(r.age) !== Number(age)) return false;
      if (ethnicity != null && Number(r.ethnicity) !== Number(ethnicity)) return false;
      if (party != null && Number(r.party_reg) !== Number(party)) return false;
      if (education != null && Number(r.education) !== Number(education)) return false;
      return true;
    };
  }
  
  // If you want to show labels elsewhere:
  export const GENDER = [
    { value: null, label: "All" },
    { value: 1,    label: "Men" },
    { value: 2,    label: "Women" },
  ];
  
  export const AGE = [
    { value: null, label: "All" },
    { value: 1,    label: "18–34" },
    { value: 2,    label: "35–64" },
    { value: 3,    label: "65+" },
  ];
  
  export const ETHNICITY = [
    { value: null, label: "All" },
    { value: 1,    label: "White" },
    { value: 2,    label: "Black" },
    { value: 3,    label: "Hispanic" },
    { value: 4,    label: "Asian" },
    { value: 5,    label: "Other" },
  ];
  
  export const PARTY = [
    { value: null, label: "All" },
    { value: 1,    label: "Dem" },
    { value: 2,    label: "Rep" },
    { value: 3,    label: "Ind" },
    { value: 4,    label: "None" },
  ];
  
  export const EDU = [
    { value: null, label: "All" },
    { value: 1,    label: "No degree" },
    { value: 2,    label: "Degree" },
  ];
  

export function baseColorForLikertKey(group, key) {
  const pol = group?.polarity || {};

  const tag = Object.entries(pol).find(([_, polKey]) => {
    if (Array.isArray(polKey)) return polKey.includes(key);
    return polKey === key;
  })?.[0];

  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}

export function getDemoAIConfig() {
  const { groupsById } = getAIConfig();
  const { ai_impact_life, ai_impact_society, ai_who_regulates, ai_concern_job_losses } = groupsById;
  return { groupsById: { ai_impact_life, ai_impact_society, ai_who_regulates, ai_concern_job_losses } };
}

// Tab-as-config default export
export default {
  tab: "ai",
  label: "AI & Technology",
  get metrics() { return getAIConfig().groupsById; },
};
